(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-certified-band"] && !Shopify.designMode) return;
  try {
    
(function(){
  var sel='.wb-certband__copy[data-wb-reveal]';
  function go(){
    var els=Array.prototype.filter.call(document.querySelectorAll(sel),function(e){return !e.classList.contains('wb-in')&&!e.hasAttribute('data-wb-observed');});
    if(!els.length)return;
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('wb-in');});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('wb-in');io.unobserve(x.target);}});},{threshold:.2});
    els.forEach(function(e){e.setAttribute('data-wb-observed','');io.observe(e);});
  }
  if(document.readyState!=='loading')go();else document.addEventListener('DOMContentLoaded',go);
  document.addEventListener('shopify:section:load',go);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)go();});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-design-wall"] && !Shopify.designMode) return;
  try {
    
(function () {
  function wire(root) {
    root.querySelectorAll('.wb-card').forEach(function (card) {
      var v = card.querySelector('video');
      if (!v || card.dataset.wbWallClip === 'on') { return; }
      card.dataset.wbWallClip = 'on';
      function loadPoster() {
        var poster = v.getAttribute('data-wb-wall-poster');
        if (poster) { v.setAttribute('poster', poster); v.removeAttribute('data-wb-wall-poster'); }
        var fallback = v.querySelector('img[data-wb-wall-src]');
        if (fallback) { fallback.setAttribute('src', fallback.getAttribute('data-wb-wall-src')); fallback.removeAttribute('data-wb-wall-src'); }
      }
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) {
            loadPoster(); observer.disconnect();
          }
        }, { rootMargin: '200px 0px' });
        observer.observe(v);
      } else { loadPoster(); }
      card.addEventListener('mouseenter', function () { loadPoster(); v.play().catch(function () {}); });
      card.addEventListener('mouseleave', function () { v.pause(); });
    });
  }
  function boot() { document.querySelectorAll('[data-wb-wall]').forEach(wire); }
  if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-drop-board"] && !Shopify.designMode) return;
  try {
    
(function(){
  function pad(n){return (n<10?'0':'')+n;}
  function initBoard(board){
    if(board.hasAttribute('data-drop-init'))return;
    board.setAttribute('data-drop-init','');
    var raw=board.getAttribute('data-target');
    var target=raw?new Date(raw).getTime():NaN;
    var cd=board.querySelector('[data-drop-countdown]');
    var dropped=board.querySelector('[data-drop-dropped]');
    var nums={
      days:board.querySelector('[data-unit="days"]'),
      hours:board.querySelector('[data-unit="hours"]'),
      mins:board.querySelector('[data-unit="mins"]'),
      secs:board.querySelector('[data-unit="secs"]')
    };
    function showDropped(){
      if(cd)cd.setAttribute('hidden','');
      if(dropped)dropped.removeAttribute('hidden');
    }
    function tick(){
      if(isNaN(target)){return;}
      var diff=target-Date.now();
      if(diff<=0){showDropped();if(board._t){clearInterval(board._t);board._t=null;}return;}
      var s=Math.floor(diff/1000);
      var d=Math.floor(s/86400);s-=d*86400;
      var h=Math.floor(s/3600);s-=h*3600;
      var m=Math.floor(s/60);s-=m*60;
      if(nums.days)nums.days.textContent=pad(d);
      if(nums.hours)nums.hours.textContent=pad(h);
      if(nums.mins)nums.mins.textContent=pad(m);
      if(nums.secs)nums.secs.textContent=pad(s);
    }
    tick();
    if(!isNaN(target)&&target-Date.now()>0){board._t=setInterval(tick,1000);}
  }
  function go(){document.querySelectorAll('.wb-drop').forEach(initBoard);}
  if(document.readyState!=='loading')go();else document.addEventListener('DOMContentLoaded',go);
  document.addEventListener('shopify:section:load',go);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)go();});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-follow-cards"] && !Shopify.designMode) return;
  try {
    
(function(){
  function go(){
    var els=Array.prototype.filter.call(document.querySelectorAll('.wb-follow__card[data-wb-reveal]'),function(e){return !e.classList.contains('wb-in')&&!e.hasAttribute('data-wb-observed');});
    if(!els.length)return;
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('wb-in');});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('wb-in');io.unobserve(x.target);}});},{threshold:.2});
    els.forEach(function(e){e.setAttribute('data-wb-observed','');io.observe(e);});
  }
  if(document.readyState!=='loading')go();else document.addEventListener('DOMContentLoaded',go);
  document.addEventListener('shopify:section:load',go);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)go();});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-gift-bundle"] && !Shopify.designMode) return;
  try {
    
(function(){
  function go(){
    var els=Array.prototype.filter.call(document.querySelectorAll('.wb-bundle__panel[data-wb-reveal]'),function(e){return !e.classList.contains('wb-in')&&!e.hasAttribute('data-wb-observed');});
    if(!els.length)return;
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('wb-in');});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('wb-in');io.unobserve(x.target);}});},{threshold:.2});
    els.forEach(function(e){e.setAttribute('data-wb-observed','');io.observe(e);});
  }
  if(document.readyState!=='loading')go();else document.addEventListener('DOMContentLoaded',go);
  document.addEventListener('shopify:section:load',go);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)go();});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-hero-streetwear"] && !Shopify.designMode) return;
  try {
    
(function(){
  function reveals(){
    var els=Array.prototype.filter.call(document.querySelectorAll('.wb-hs [data-wb-reveal]'),function(e){return !e.classList.contains('wb-in')&&!e.hasAttribute('data-wb-observed');});
    if(!els.length)return;
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('wb-in');});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('wb-in');io.unobserve(x.target);}});},{threshold:.1});
    els.forEach(function(e){e.setAttribute('data-wb-observed','');io.observe(e);});
  }
  function go(){reveals();}
  if(document.readyState!=='loading')go();else document.addEventListener('DOMContentLoaded',go);
  document.addEventListener('shopify:section:load',go);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)go();});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-newsletter"] && !Shopify.designMode) return;
  try {
    
(function(){
  function go(){
    var els=Array.prototype.filter.call(document.querySelectorAll('.wb-news__wrap[data-wb-reveal]'),function(e){return !e.classList.contains('wb-in')&&!e.hasAttribute('data-wb-observed');});
    if(!els.length)return;
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('wb-in');});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('wb-in');io.unobserve(x.target);}});},{threshold:.2});
    els.forEach(function(e){e.setAttribute('data-wb-observed','');io.observe(e);});
  }
  if(document.readyState!=='loading')go();else document.addEventListener('DOMContentLoaded',go);
  document.addEventListener('shopify:section:load',go);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)go();});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-product-grid"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function reveals(){
    var els=Array.prototype.filter.call(document.querySelectorAll('.wb-grid [data-wb-reveal]'),function(e){return !e.classList.contains('wb-in')&&!e.hasAttribute('data-wb-observed');});
    if(!els.length)return;
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('wb-in');});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('wb-in');io.unobserve(x.target);}});},{threshold:.12});
    els.forEach(function(e){e.setAttribute('data-wb-observed','');io.observe(e);});
  }
  function tilt(){
    if(reduce)return;
    if(!window.matchMedia||!window.matchMedia('(hover:hover) and (pointer:fine)').matches)return;
    document.querySelectorAll('.wb-grid--tilt .wb-grid__card').forEach(function(c){
      if(c.hasAttribute('data-wb-tilt'))return;
      c.setAttribute('data-wb-tilt','');
      c.addEventListener('mousemove',function(e){
        var r=c.getBoundingClientRect();
        var x=(e.clientX-r.left)/r.width-.5;
        var y=(e.clientY-r.top)/r.height-.5;
        c.style.transform='perspective(700px) rotateY('+(x*6)+'deg) rotateX('+(-y*6)+'deg) translateY(-4px)';
      });
      c.addEventListener('mouseleave',function(){c.style.transform='';});
    });
  }
  function go(){reveals();tilt();}
  if(document.readyState!=='loading')go();else document.addEventListener('DOMContentLoaded',go);
  document.addEventListener('shopify:section:load',go);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)go();});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-reels-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  function go(){
    var els=Array.prototype.filter.call(document.querySelectorAll('.wb-reels__head[data-wb-reveal]'),function(e){return !e.classList.contains('wb-in')&&!e.hasAttribute('data-wb-observed');});
    if(!els.length)return;
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('wb-in');});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('wb-in');io.unobserve(x.target);}});},{threshold:.2});
    els.forEach(function(e){e.setAttribute('data-wb-observed','');io.observe(e);});
  }
  if(document.readyState!=='loading')go();else document.addEventListener('DOMContentLoaded',go);
  document.addEventListener('shopify:section:load',go);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)go();});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-seasonal-rail"] && !Shopify.designMode) return;
  try {
    
(function(){
  function reveals(){
    var els=Array.prototype.filter.call(document.querySelectorAll('.wb-srail [data-wb-reveal]'),function(e){return !e.classList.contains('wb-in')&&!e.hasAttribute('data-wb-observed');});
    if(els.length){
      if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('wb-in');});}
      else{
        var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('wb-in');io.unobserve(x.target);}});},{threshold:.12});
        els.forEach(function(e){e.setAttribute('data-wb-observed','');io.observe(e);});
      }
    }
  }
  function initDrag(rail){
    if(rail.hasAttribute('data-srail-init'))return;
    rail.setAttribute('data-srail-init','');
    var down=false,moved=false,startX=0,startScroll=0;
    rail.addEventListener('pointerdown',function(e){
      if(e.pointerType==='touch')return;
      down=true;moved=false;startX=e.clientX;startScroll=rail.scrollLeft;
    });
    rail.addEventListener('pointermove',function(e){
      if(!down)return;
      var dx=e.clientX-startX;
      if(Math.abs(dx)>4){moved=true;rail.classList.add('is-dragging');}
      rail.scrollLeft=startScroll-dx;
    });
    function end(){if(!down)return;down=false;setTimeout(function(){rail.classList.remove('is-dragging');},0);}
    rail.addEventListener('pointerup',end);
    rail.addEventListener('pointerleave',end);
    rail.addEventListener('pointercancel',end);
    rail.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();}},true);
  }
  function go(){reveals();document.querySelectorAll('.wb-srail__rail[data-srail]').forEach(initDrag);}
  if(document.readyState!=='loading')go();else document.addEventListener('DOMContentLoaded',go);
  document.addEventListener('shopify:section:load',go);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)go();});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-slogan-wall"] && !Shopify.designMode) return;
  try {
    
(function(){
  var STORE='wb-cheeky-revealed';
  function revealed(){try{return JSON.parse(sessionStorage.getItem(STORE)||'[]');}catch(e){return [];}}
  function remember(h){try{var a=revealed();if(a.indexOf(h)<0){a.push(h);sessionStorage.setItem(STORE,JSON.stringify(a));}}catch(e){}}

  function initWall(wall){
    if(wall.hasAttribute('data-wb-init'))return;
    wall.setAttribute('data-wb-init','');
    // restore revealed cheeky tiles
    var seen=revealed();
    wall.querySelectorAll('.wb-slogan__tile--rude').forEach(function(t){
      if(seen.indexOf(t.getAttribute('data-handle'))>=0)t.classList.add('wb-revealed');
    });
    wall.querySelectorAll('.wb-slogan__gate').forEach(function(btn){
      btn.addEventListener('click',function(e){
        e.preventDefault();e.stopPropagation();
        var tile=btn.closest('.wb-slogan__tile');
        tile.classList.add('wb-revealed');
        remember(tile.getAttribute('data-handle'));
      });
    });

    // chip filtering
    var chips=wall.querySelectorAll('.wb-slogan__chip');
    var tiles=Array.prototype.slice.call(wall.querySelectorAll('.wb-slogan__tile'));
    function matches(tile,f){
      if(f==='all')return true;
      if(f==='cheeky')return (tile.getAttribute('data-tags')||'').indexOf('rude')>=0;
      return (tile.getAttribute('data-cols')||'').split(/\s+/).indexOf(f)>=0;
    }
    chips.forEach(function(chip){
      var f=chip.getAttribute('data-filter');
      var n=tiles.filter(function(t){return matches(t,f);}).length;
      var nEl=chip.querySelector('.wb-slogan__chipn');
      if(nEl)nEl.textContent='('+n+')';
      chip.addEventListener('click',function(){
        chips.forEach(function(c){c.classList.remove('is-on');});
        chip.classList.add('is-on');
        tiles.forEach(function(t){t.classList.toggle('is-hidden',!matches(t,f));});
      });
    });
  }

  function reveals(){
    var els=Array.prototype.filter.call(document.querySelectorAll('.wb-slogan [data-wb-reveal]'),function(e){return !e.classList.contains('wb-in')&&!e.hasAttribute('data-wb-observed');});
    if(!els.length)return;
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('wb-in');});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('wb-in');io.unobserve(x.target);}});},{threshold:.08});
    els.forEach(function(e){e.setAttribute('data-wb-observed','');io.observe(e);});
  }

  function go(){document.querySelectorAll('.wb-slogan').forEach(initWall);reveals();}
  if(document.readyState!=='loading')go();else document.addEventListener('DOMContentLoaded',go);
  document.addEventListener('shopify:section:load',go);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)go();});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-stats-countup"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function fmt(v,dec){ return dec>0 ? v.toFixed(dec) : Math.round(v).toString(); }
  function run(el){
    if(el.hasAttribute('data-wb-done'))return;
    el.setAttribute('data-wb-done','');
    var target=parseFloat(el.getAttribute('data-wb-count'))||0;
    var suf=el.getAttribute('data-suffix')||'';
    var pre=el.getAttribute('data-prefix')||'';
    var dec=parseInt(el.getAttribute('data-decimals')||'0',10);
    if(reduce){el.textContent=pre+fmt(target,dec)+suf;return;}
    var start=null,dur=1100;
    function step(ts){
      start=start||ts;
      var p=Math.min((ts-start)/dur,1);
      var eased=1-Math.pow(1-p,3);
      el.textContent=pre+fmt(target*eased,dec)+suf;
      if(p<1)requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function go(){
    var stats=Array.prototype.filter.call(document.querySelectorAll('.wb-stats__stat[data-wb-reveal]'),function(s){return !s.hasAttribute('data-wb-observed');});
    if(!stats.length)return;
    if(!('IntersectionObserver' in window)){
      stats.forEach(function(s){s.setAttribute('data-wb-observed','');s.classList.add('wb-in');s.querySelectorAll('[data-wb-count]').forEach(run);});
      return;
    }
    var io=new IntersectionObserver(function(en){en.forEach(function(x){
      if(x.isIntersecting){x.target.classList.add('wb-in');x.target.querySelectorAll('[data-wb-count]').forEach(run);io.unobserve(x.target);}
    });},{threshold:.3});
    stats.forEach(function(s){s.setAttribute('data-wb-observed','');io.observe(s);});
  }
  if(document.readyState!=='loading')go();else document.addEventListener('DOMContentLoaded',go);
  document.addEventListener('shopify:section:load',go);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)go();});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-ugc-wall"] && !Shopify.designMode) return;
  try {
    
(function(){
  function go(){
    var els=Array.prototype.filter.call(document.querySelectorAll('.wb-ugc [data-wb-reveal]'),function(e){return !e.classList.contains('wb-in')&&!e.hasAttribute('data-wb-observed');});
    if(!els.length)return;
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('wb-in');});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('wb-in');io.unobserve(x.target);}});},{threshold:.1});
    els.forEach(function(e){e.setAttribute('data-wb-observed','');io.observe(e);});
  }
  if(document.readyState!=='loading')go();else document.addEventListener('DOMContentLoaded',go);
  document.addEventListener('shopify:section:load',go);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)go();});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb2-feed"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.wb2FeedReady === '1') return;
    root.dataset.wb2FeedReady = '1';

    var tiles = root.querySelectorAll('.wb2feed__tile');

    root.querySelectorAll('.wb2feed__chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var want = chip.getAttribute('data-f');
        root.querySelectorAll('.wb2feed__chip').forEach(function (c) {
          c.setAttribute('aria-pressed', String(c === chip));
        });
        tiles.forEach(function (t) {
          var show = want === 'all' || t.getAttribute('data-tier') === want;
          t.classList.toggle('is-hidden', !show);
        });
      });
    });

    tiles.forEach(function (t) {
      if (t.classList.contains('is-locked')) {
        t.addEventListener('click', function (e) {
          if (!t.classList.contains('is-open')) { e.preventDefault(); t.classList.add('is-open'); }
        });
      }
      var v = t.querySelector('video');
      if (v) {
        t.addEventListener('mouseenter', function () { v.play().catch(function () {}); });
        t.addEventListener('mouseleave', function () { v.pause(); });
      }
    });
  }

  function boot() { document.querySelectorAll('[data-wb2-feed]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb2-hero-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.wb2HeroReady === '1') return;
    root.dataset.wb2HeroReady = '1';

    var media = root.querySelectorAll('[data-c]');
    var name = root.querySelector('[data-wb2-pickname]');
    var requestedId = null;
    var requestedLabel = null;

    function loadVideo(video) {
      var source = video.getAttribute('data-src');
      if (!source || video.getAttribute('src')) return;
      video.setAttribute('src', source);
      video.removeAttribute('data-src');
      video.load();
    }

    function loadImage(image) {
      var source = image.getAttribute('data-src');
      if (!source || image.getAttribute('src')) return;
      var sourceSet = image.getAttribute('data-srcset');
      if (sourceSet) {
        image.setAttribute('srcset', sourceSet);
      }
      image.setAttribute('src', source);
    }

    function requestImage(image) {
      if (image.dataset.wb2Loading === '1') return;
      image.dataset.wb2Loading = '1';
      image.addEventListener('load', function () {
        delete image.dataset.wb2Loading;
        image.removeAttribute('data-src');
        image.removeAttribute('data-srcset');
        show(requestedId, requestedLabel);
      }, { once: true });
      image.addEventListener('error', function () {
        delete image.dataset.wb2Loading;
        image.removeAttribute('src');
        image.removeAttribute('srcset');
      }, { once: true });
      loadImage(image);
    }

    function show(id, label) {
      requestedId = id;
      requestedLabel = label;
      var pendingImage = null;
      root.querySelectorAll('.wb2hero__media').forEach(function (m) {
        if (m.getAttribute('data-c') === id) pendingImage = m.querySelector('img[data-src]');
      });
      if (pendingImage) {
        requestImage(pendingImage);
        return;
      }

      root.querySelectorAll('.wb2hero__media').forEach(function (m) {
        var on = m.getAttribute('data-c') === id;
        m.classList.toggle('is-on', on);
        var v = m.querySelector('video');
        if (v) { if (on) { loadVideo(v); v.play().catch(function () {}); } else { v.pause(); } }
      });
      root.querySelectorAll('.wb2hero__sw').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-c') === id));
      });
      if (name && label) name.textContent = label;
    }

    root.querySelectorAll('.wb2hero__sw').forEach(function (b) {
      b.addEventListener('click', function () {
        show(b.getAttribute('data-c'), b.getAttribute('aria-label'));
      });
    });

    // Browsers defer autoplay in a backgrounded tab; nudge the active clip when it is looked at.
    function nudge() {
      var on = root.querySelector('.wb2hero__media.is-on video');
      if (!on) return;
      if (on.readyState === 0) on.load();
      on.play().catch(function () {});
    }
    nudge();
    window.addEventListener('load', nudge);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) nudge(); });
  }

  function boot() { document.querySelectorAll('[data-wb2-hero]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
